import React from 'react';
import './Comp.css';

const Comp = (props) => {
    return (
        <div className="comp">
            <div className="image">
                <img src={props.src} className="assess-image" alt="webgear" />
            </div>
            <p className="name">{props.name}</p>
            <p className="conname">{props.conname}</p>
        </div>
    )
}

export default Comp;